import React from 'react';
import { Spinner, SpinnerSize, Pivot, PivotItem } from '@fluentui/react';
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from '../../helpers/HelperMethods';
import MySites from "./MySites";

const MySitesTabs = ({ parentPivotKey, isLoadingOwnedSites, isLoadingcoOwnedSites, ownedSites, coOwnedSites, ownedSitesPageNavi, coOwnedSitesPageNavi, editCallback }) => {

    const defaultSelectedKey = getPivotItemKeyFromUrl('Owned', parentPivotKey);
    const spinner = <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />;

    return (
        <div>
            <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl(parentPivotKey)}>
                <PivotItem itemKey='Owned' headerText='Administrated' itemCount={isLoadingOwnedSites ? undefined : ownedSites.totalCount}>
                    {
                        isLoadingOwnedSites ? spinner
                        : 
                        <div style={pivotItemStyles}>
                            <MySites sites={ownedSites.results} editCallback={editCallback} mySitesType={'ownedSites'}/>
                            {ownedSitesPageNavi}
                        </div>
                    }
                </PivotItem>
                <PivotItem itemKey='CoOwned' headerText='Co-administrated' itemCount={isLoadingcoOwnedSites ? undefined : coOwnedSites.totalCount}>
                    {
                        isLoadingcoOwnedSites ? spinner
                        : 
                        <div style={pivotItemStyles}>
                            <MySites sites={coOwnedSites.results} editCallback={editCallback} mySitesType={'coOwnedSites'}/>
                            {coOwnedSitesPageNavi}
                        </div>
                    }
                </PivotItem>
            </Pivot>
        </div>
    );

}

const pivotStyles = {
    root: {
        marginBottom: 20
    },
    linkContent: {
        fontSize: 16,
        flex: 'auto'
    }
}

const pivotItemStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    width: "100%"
}

export default MySitesTabs


// WEBPACK FOOTER //
// ./src/components/ManageCenter/MySitesTabs.js